var productList = {
	pages: [
		$('.page-lookbook')
	],

	init: function() {
		for (var i = productList.pages.length - 1; i >= 0; i--) {
			if (productList.pages[i].length) {
				pagination.setProductClasses();
			}
		}
	}
};